export const services = [
    {
      name: "Legal Document Drafting and Review",
      description: "Offer professional assistance in drafting and reviewing legal documents such as contracts, agreements, wills, and legal opinions.",
    },
    {
      name: "Consultation Services",
      description: "Provide legal advice through general consultations, case-specific discussions, legal strategy sessions, and pre-litigation advice.",
    },
    {
      name: "Dispute Resolution Services",
      description: "Facilitate mediation and arbitration services, emphasizing alternative dispute resolution (ADR) methods.",
    },
    {
      name: "Notarial Services",
      description: "Offer document notarization services, including the authentication of affidavits and sworn statements.",
    },
    {
      name: "Litigation Support",
      description: "Assist with legal research, case analysis, and trial preparation to support clients in litigation processes.",
    },
    {
      name: "Regulatory Compliance",
      description: "Conduct compliance audits, assist with regulatory filings, and provide advisory services on regulatory compliance.",
    },
    {
      name: "Legal Representation",
      description: "Provide advocacy services, represent clients in court appearances, and offer representation in legal proceedings.",
    },
    {
      name: "Intellectual Property Services",
      description: "Assist with trademark registration, patent drafting and filing, and protection of intellectual property rights.",
    },
    {
      name: "Family Law Services",
      description: "Handle matters related to divorce and separation agreements, child custody and support, and adoption services.",
    },
    {
      name: "Real Estate Services",
      description: "Offer services such as property title searches, lease agreement drafting, and assistance with property transactions.",
    },
    {
      name: "Corporate and Business Services",
      description: "Assist with business formation and registration, contract negotiation and drafting, and provide corporate governance advice.",
    },
    {
      name: "Employment and Labor Law Services",
      description: "Draft employment contracts, provide assistance with workplace dispute resolution, and ensure labor law compliance.",
    },
    {
      name: "Cyber Law and Data Protection",
      description: "Address issues related to data privacy compliance, cybersecurity legal advice, and prevention of cybercrime.",
    },
    {
      name: "Legal Training and Workshops",
      description: "Conduct legal education programs, training sessions on specific legal topics, and workshops for legal professionals.",
    },
    {
      name: "Customized Legal Services",
      description: "Offer tailored legal solutions based on client needs and provide project-based legal support.",
    },
  ];
  